import React, { useCallback } from 'react';

import { DynamicFormField } from '../../ui/form'

import { getB3ShippingAddressExtras, getB3BillingAddressExtras } from './address'

import CheckoutStepType from '../../checkout/CheckoutStepType';


interface B3AddressFromProps {
  setFieldValue?: any,
  type: CheckoutStepType | string | undefined,
  setShippingFieldValue?: any,
}

const B3AddressFrom = ({type}:B3AddressFromProps) => {


  const isBilling = (type && type === CheckoutStepType.Billing) 

  const B3AddressExtras = isBilling ? getB3BillingAddressExtras() : getB3ShippingAddressExtras()

  if (!B3AddressExtras || !B3AddressExtras.length) {
    return null
  }

  return(
    <div className="addressExtrasContainer">
      {B3AddressExtras && B3AddressExtras.map((field: any) => {
            const paymentFieldName = field.name

            const basicFiledProps = {
                autocomplete: field.name,
                extraClass: `dynamic-form-field--${paymentFieldName}`,
                field: field,
                inputId: paymentFieldName,
                key: `${field.id}-${field.name}`,
                label: field.label,
                onChange: useCallback(() => {}, []),
                parentFieldName: 'b2bCustomFields',
                placeholder: '',
            }

            if (!field.visibleToEnduser) return null

            return (
                <DynamicFormField
                    {...basicFiledProps}
                />
            )
        })}
    </div>
  )
}

export default React.memo(B3AddressFrom)